module.exports = __webpack_public_path__ + "static/media/stockProfile.4fa25afa.svg";